export default function loadFrameData(context, payload, done) {
  const { account } = payload;
  context.dispatch('FRAME_DATA_LOADED', { account });
  if (done) done();
}
